import { Modal } from '@ownyou/ui-components';

export interface ChatScaffoldModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ChatScaffoldModal({ isOpen, onClose }: ChatScaffoldModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Ask OwnYou"
      description="Chat returns in a later slice; this scaffold keeps the Aurora shell contract honest."
      size="lg"
    >
      <div data-testid="chat-modal" className="space-y-4">
        <div
          className="rounded-xl border p-4"
          style={{
            borderColor: 'var(--aurora-ink-line)',
            background: 'var(--aurora-card)',
            color: 'var(--aurora-ink)',
            fontFamily: 'var(--aurora-font-ui)',
          }}
        >
          <p className="text-sm">
            OwnYou chat will dispatch through the later route-executor slice. No prompt is sent from
            this scaffold.
          </p>
        </div>
        <div className="flex gap-2">
          <input
            data-testid="chat-modal-input"
            disabled
            placeholder="Chat execution lands in Slice 9"
            className="min-w-0 flex-1 rounded-full border px-4 py-2 text-sm disabled:opacity-60"
            style={{
              borderColor: 'var(--aurora-ink-line)',
              background: 'var(--aurora-card-solid)',
              color: 'var(--aurora-ink-dim)',
            }}
          />
          <button
            type="button"
            disabled
            className="rounded-full px-4 py-2 text-sm font-medium disabled:opacity-60"
            style={{
              background: 'var(--aurora-accent)',
              color: 'var(--aurora-card-solid)',
            }}
          >
            Send
          </button>
        </div>
      </div>
    </Modal>
  );
}
